<template>
  <div :id="glass.article_nr" class="glassitem-container" :data-sort-color="sortColors">
    <article class="glasses-list-item">
      <div class="glasses-list-item-header">
        <span v-if="glass.aktuell" class="badge bg-secondary">{{ translate('new') }}</span>
        <span v-else></span>
        <a ref="wishlistbtn" class="eon-add-wishlist-btn" :data-color-code="colors[0].color_nr" :data-artnr="glass.article_nr"><i class="fa-regular fa-star"></i></a>
      </div>
      <div class="glass-item-inner">
        <div class="glass-item-image-holder">
          <a ref="imglink" @click="$emit('itemClicked', $event, glass.article_nr)" class="glass-item-link" :href="getUrl(colors[0].color_nr)">
          <img ref="main" :src="mainImage()"  class="img-fluid" />
          </a>
          <div class="glass-item-text-holder">
            <h5 class="glass-item-title"><a ref="titlelink" @click="$emit('itemClicked', $event, glass.article_nr)" class="glass-item-link" :href="getUrl(colors[0].color_nr)"><span v-if="showBrandlabel">{{ glass.brandLabel }}&nbsp;</span>{{glass.article_nr}}</a></h5>
            <ul class="glass-item-colors">
              <li v-for="(color, index) in sortedColors(colors)" :key="index" :class="color.imageMissing ? 'item-color--imageMissing' : 'item-color'">
                <a @click="changeColor" v-iload="" :class="'color-icon color-' + color.class" :data-img="getImage(color)" :data-idx="index"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import config from '../config.js'
import { computed } from 'vue'
import {eonUserState} from '@/composable/eonUserState'
import {buildColorImageName} from '@/composable/eonUtils'
export default {
  name: "GlassItem",
  props: {
    Glassitem: Object,
    baseurl: String,
    translate: Function,
    brandlabel: String,
    sortColors: Array,
    config: Object

  },
  setup(props) {

    const glass = computed(() => { return props.Glassitem })
    const {setEonUserstate} = eonUserState()
    const colors =  computed(() => {
      const sorted = props.Glassitem.colors
      if(props.sortColors.length) {
        return sorted.sort(function(a , b){
          if(props.sortColors.includes(a.group)) {
            return -1
          }
          if(b.group != undefined) {
            return 1
          }
        })
      } else {
        return sorted
      }
    })
    const currentimage =  computed(() => {
      return config.glassesBaseUrl + buildColorImageName(glass.value.colors[0], props.config.preferredView)
    })
    const showBrandlabel = computed(() => {
      return props.config.hideBrandLabels === undefined || props.config.hideBrandLabels === false
    })
    return {
      glass,
      colors,
      getImage(color) {
        return config.glassesBaseUrl + buildColorImageName(color, props.config.preferredView)
      },
      mainImage: function() {
        return this.currentimage
      },
      showBrandlabel,
      setEonUserstate,
      currentimage,
      buildColorImageName
    }
  },
  methods: {
    changeColor: function (e) {
      this.currentimage = e.target.getAttribute('data-img')
      this.$refs.main.src = e.target.getAttribute('data-img')
      const idx = e.target.getAttribute('data-idx')
      this.$refs.imglink.setAttribute('href', this.getUrl(this.glass.colors[idx].color_nr))
      this.$refs.titlelink.setAttribute('href', this.getUrl(this.glass.colors[idx].color_nr))
      this.$refs.wishlistbtn.setAttribute('data-color-code', this.glass.colors[idx].color_nr)
    },
    getUrl: function(color_nr) {
      return this.baseurl + this.glass.article_nr + color_nr
    },

    sortedColors: function (color) {
      return color.sort(
          (a,b) => {
            if (a.imageMissing) {
              return -1
            } else if (b.imageMissing)  {
              return 1
            }
            return 0
          }
      )
    }
  },

  directives: {
    // enables v-focus in template
    iload: function(now) {
      const image = new Image();
      image.src = now.getAttribute('data-img')
    }
  }
};
</script>

<style scoped>
@import "glassitem.css";
</style>